// filepath: /d:/Bridges/DDNS/ddnsmanager_react/src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            "Confirm Delete": "Confirm Delete",
            "Are you sure you want to delete": "Are you sure you want to delete",
            "Type the name of the subdomain to confirm": "Type the name of the subdomain to confirm",
            "Cancel": "Cancel",
            "Delete": "Delete",
            "Enable": "Enable",
            "Disable": "Disable",
            "Are you sure you want to": "Are you sure you want to",
            "Project": "Project",
            "Add Subdomain": "Add Subdomain",
            "Delete Project": "Delete Project",
            "Edit": "Edit",
            "Download Script": "Download Script",
            "DNS update is disabled": "DNS update is disabled",
            "DNS has been updated within the interval period.": "DNS has been updated within the interval period.",
            "No updates within the interval period.": "No updates within the interval period.",

            "project": "Project",
            "addSubdomain": "Add Subdomain",
            "deleteProject": "Delete Project",
            "status": "Status",
            "subdomain": "Subdomain",
            "ip": "IP",
            "description": "Description",
            "updateInterval": "Update Interval",
            "lastUpdated": "Last Updated",
            "actions": "Actions",
            "edit": "Edit",
            "downloadScript": "Download Script",
            "enable": "Enable",
            "disable": "Disable",
            "delete": "Delete",
            "confirmDelete": "Confirm Delete",
            "cancel": "Cancel",
            "save": "Save",
            "dnsUpdateDisabled": "DNS update is disabled",
            "dnsUpdatedWithinInterval": "DNS has been updated within the interval period.",
            "noUpdatesWithinInterval": "No updates within the interval period.",
            "secs": "secs",
            "areYouSureDelete": "Are you sure you want to delete",
            "typeNameToConfirm": "Type the name of the {{type}} to confirm?",
            "nameDoesNotMatch": "Name does not match",
            "addProject": "Add Project",
            "editProject": "Edit Project",

            "editDdns.title": 'Edit DDNS Entry',
            "addDdns.title": 'Add DDNS Entry',

            "errors.subdomainExists": 'Subdomain already exists',
            "errors.invalidSubdomain": 'Invalid subdomain',
            "errors.invalidProjectName": 'Invalid project name',
            "errors.invalidIpAddress": 'Invalid IP address',
            "errors.invalidTimeout": 'Invalid time out value',

            "login": "Login",
            "logoff": "Logout",
            "add": "Add",

            "alldnsdisabled": "All DNS updates are disabled",
            "alldnsgreen": "All DNS updates are within the interval period",
            "alldnsred": "No DNS updates within the interval period",
            "orangedns": "Some DNS updates are within the interval period, some are not",

            "Refresh": "Refresh",
            "Refreshing": "Refreshing",

            "Deletesuccessful": "Delete successful",
            "Success": "Success",
            "Error": "Error",
            "Savesuccessful": "Save successful"
        }
    },
    ja: {
        translation: {
            "Confirm Delete": "削除確認",
            "Are you sure you want to delete": "次のアイテムを削除しますか?",
            "Type the name of the subdomain to confirm": "確認のためサブドメインの名前を入力してください。",
            "Cancel": "キャンセル",
            "Delete": "削除",
            "Enable": "有効化",
            "Disable": "無効化",
            "Are you sure you want to": "本当にしたいですか",
            "Project": "プロジェクト",
            "Add Subdomain": "サブドメイン追加",
            "Delete Project": "プロジェクト削除",
            "Edit": "編集",
            "Download Script": "スクリプトダウンロード",
            "DNS update is disabled": "DNSの更新が無効です",
            "DNS has been updated within the interval period.": "DNSは間隔期間内に更新されました。",
            "No updates within the interval period.": "間隔期間内に更新はありません。",

            "project": "プロジェクト",
            "addSubdomain": "サブドメイン追加",
            "deleteProject": "プロジェクト削除",
            "status": "ステータス",
            "subdomain": "サブドメイン",
            "ip": "IPアドレス",
            "description": "説明",
            "updateInterval": "更新間隔",
            "lastUpdated": "最終更新",
            "actions": "操作",
            "edit": "編集",
            "downloadScript": "スクリプトをダウンロード",
            "enable": "有効化",
            "disable": "無効化",
            "delete": "削除",
            "confirmDelete": "削除確認",
            "cancel": "キャンセル",
            "save": "保存",
            "dnsUpdateDisabled": "DNS更新が無効になっています",
            "dnsUpdatedWithinInterval": "間隔期間内にDNSが更新されました",
            "noUpdatesWithinInterval": "間隔期間内に更新がありません",
            "secs": "秒",
            "areYouSureDelete": "本当に削除しますか",
            "typeNameToConfirm": "確認のため{{type}}の名前を入力してください",
            "nameDoesNotMatch": "名前が一致しません",
            "addProject": "プロジェクト追加",
            "editProject": "プロジェクト編集",

            "editDdns.title": 'DDNS エントリー編集',
            "addDdns.title": 'DDNS エントリー追加',


            "errors.subdomainExists": 'サブドメインが既に存在します',
            "errors.invalidSubdomain": '無効なサブドメインです',
            "errors.invalidProjectName": '無効なプロジェクト名です',
            "errors.invalidIpAddress": '無効なIPアドレスです',
            "errors.invalidTimeout": '無効なタイムアウト値です',

            "login": "ログイン",
            "logout": "ログアウト",
            "add": "追加",

            "alldnsdisabled": "すべてのDNS更新が無効になっています",
            "alldnsgreen": "すべてのサブドメインがオンラインです",
            "alldnsred": "すべてのサブドメインがオフラインです",
            "orangedns": "サブドメインの一部がオフラインです",

            "Refresh": "更新",
            "Refreshing": "更新中",

            "Deletesuccessful": "削除が完了しました",
            "Success": "完了",
            "Error": "エラー : エラーが発生しました",
            "Savesuccessful": "処理が完了しました"
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "ja", // default language
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;